import Logo from '../brand/Logo';

// Reduced header — logo lockup only, transparent over the page. Sits above every
// CenteredCardTempScreen. Rendered outside the app Router, so the logo is a plain
// anchor rather than a router link; on the card it reads as "the way back", here
// it just points home.
export function LogoHeader() {
    return (
        <header className="h-header w-full">
            <div className="flex h-full items-center px-5 md:px-[50px]">
                <a href="/" aria-label="Organic Electronics Audio — home">
                    <Logo />
                </a>
            </div>
        </header>
    );
}

export default LogoHeader;
